import axios from 'axios';

export interface SubjectAssignStudent {
  id: string;
  admissionNumber: string;
  scholarNumber?: string;
  firstName: string;
  lastName: string;
}

export interface LoadStudentsParams {
  sessionId: string;
  classId: string;
  sectionId: string;
}

export interface BulkSubjectAssignPayload {
  subjectId: string;
  academicSessionId: string;
  classId: string;
  sectionId: string;
  students: string[];
}

export interface SubjectAssignResponse {
  assigned: number;
  skipped: number;
}

export const subjectAssignApi = {
  loadStudents: async (params: LoadStudentsParams): Promise<SubjectAssignStudent[]> => {
    const response = await axios.get('/scholar-register/subject-assign/students', { params });
    return response.data;
  },

  assignSubject: async (data: BulkSubjectAssignPayload): Promise<SubjectAssignResponse> => {
    const response = await axios.post('/scholar-register/subject-assign', data);
    return response.data;
  },

  getSubjectsByClass: async (classId: string) => {
    const response = await axios.get('/system-settings/subject', { params: { classId } });
    return response.data;
  },
};
